const STORAGE_KEY = "other-store-recent-orders";
// Тот же префикс использует inline-скрипт в public/index.html.
const ORDER_TOKEN_KEY_PREFIX = "ts_order_token:";

function readAll() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota errors */
  }
}

export function saveRecentStoreOrder(storeId, orderId, accessToken) {
  if (!storeId || !orderId) {
    return;
  }
  const all = readAll();
  all[storeId] = {
    orderId,
    accessToken: accessToken || null,
    savedAt: Date.now(),
  };
  writeAll(all);
}

export function getRecentStoreOrder(storeId) {
  if (!storeId) {
    return null;
  }
  return readAll()[storeId] ?? null;
}

export function getRecentStoreOrderId(storeId) {
  return getRecentStoreOrder(storeId)?.orderId ?? null;
}

export function getRecentStoreOrderToken(storeId) {
  return getRecentStoreOrder(storeId)?.accessToken ?? null;
}

export function rememberOrderToken(orderId, accessToken) {
  if (!orderId || !accessToken) {
    return;
  }
  try {
    sessionStorage.setItem(`${ORDER_TOKEN_KEY_PREFIX}${orderId}`, accessToken);
  } catch {
    /* ignore quota errors */
  }
}

export function getRememberedOrderToken(orderId) {
  if (!orderId) {
    return null;
  }
  try {
    return sessionStorage.getItem(`${ORDER_TOKEN_KEY_PREFIX}${orderId}`);
  } catch {
    return null;
  }
}
